<!-- @format -->

<ul>
  @for (requirementRule of rules; track requirementRule) {
    <li>
      <sis-icon
        [icon]="requirementRule.result ? 'check' : 'fail'"
        [color]="requirementRule.result ? 'success' : 'danger'"
        aria-hidden="true"></sis-icon>
      {{ requirementRule.rule | personRequirementRuleName | async }}
    </li>
  }
</ul>
